<template>
  <div class="card-main">
    <slot name="top"></slot>
    <page-title
      :title-left="TitleLeft"
      :title-right="TitleRight"
      v-if="TitleShow"
    ></page-title>
    <div class="card-body">
      <transition
        name="slide-fade"
        v-for="(card, name) in CardList"
        :key="name"
      >
        <status-card-template
          v-if="CardList[name].row > 0"
          :title="CardList[name].title"
          :cardObject="CardList[name]"
          :title-show="TitleShow"
        ></status-card-template>
      </transition>
    </div>
  </div>
</template>
<script>
import PageTitle from './PageTitle'
import StatusCardTemplate from './StatusCard'
export default {
  name: 'student-status-card',
  components: {
    PageTitle,
    StatusCardTemplate
  },
  props: {
    TitleLeft: {
      type: String,
      default: ''
    },
    TitleRight: {
      type: String,
      default: ''
    },
    CardList: {
      type: Object,
      default: () => {}
    },
    updateCardPromise: {
      type: Object
    },
    TitleShow: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>
.card-main {
  // height: 100%;
  width: 100%;
  min-width: 1000px;
  // overflow-y: auto;
  position: relative;
  .card-body {
    height: calc(100% - 59px);
    width: 1000px;
    margin: 0 auto;
  }
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/student-status-card/components/PageTemplate.vue